import PageLayout from '@/components/page/page-layout'

const OrderList = () => import('@/views/order/list')
const OrderDetail = () => import('@/views/order/list/orderDetail')

const router = {
  path: '/order',
  component: PageLayout,
  redirect: '/order/list',
  name: 'Order',
  icon: 'none',
  children: [
    {
      path: 'list',
      name: 'orderList',
      component: OrderList,
      meta: {
        currentMenu: 'order',
        hideBreadcrumb: true,
        title: '订单管理'
      }
    },
    {
      path: 'detail',
      name: 'orderDetail',
      component: OrderDetail,
      meta: {
        currentMenu: 'order',
        hideBreadcrumb: true,
        title: '订单管理'
      }
    }
  ]
}

export default router
